import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileComponent } from './profile.component';
import { ProfileResolve } from './profile.resolve';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppMaterialModule } from '../../shared/appMaterial/app-material.module';
import { UserFormModule } from '../admin/users/form/user-form.module';
import { EditProfileModule } from './edit-profile/edit-profile.module';
import { PaystubsModule } from './captain/paystubs/paystubs.module';
import { RouterModule } from '@angular/router';
import { BankInformationModule } from './bank-information/bank-information.module';

@NgModule({
  imports: [
    CommonModule,
    ProfileRoutingModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    FlexLayoutModule,
    UserFormModule,
    EditProfileModule,
    PaystubsModule,
    RouterModule,
    BankInformationModule,
  ],
  declarations: [ProfileComponent],
  exports: [ProfileComponent],
  providers: [ProfileResolve],
  entryComponents: [ProfileComponent],
})
export class ProfileModule {}
